import React, { useEffect, useState } from 'react';
import { LivquestCalviLogo } from './logo';
import { SelectField } from '../select';
import { useLiv } from '../../context/liv';
import { getFirstMessagesLivquestCalvi } from '../../actions/getLanguages';
import { patchMe } from '../../actions/livquest/patchMe'; // Assuming putMe is the function to update user language
import { ChatMessage } from '../chatmessage'; // Assuming AssistantMessage is a component that handles the assistant's messages
import { getCache } from '../../actions/cache';

const HelloView = ({ startChat: _startChat }) => {
  const { setLanguage, language, languages } = useLiv(); // Access language and languages from context
  const [firstMessage, setFirstMessage] = useState('');
  const filteredLanguages = languages.filter((l) => ['fr', 'en', 'it'].includes(l.value));

  useEffect(() => {
    const browserLanguage = navigator.language.split('-')[0];
    if (filteredLanguages.some((l) => l.value === browserLanguage)) {
      setLanguage(browserLanguage);
    } else {
      setLanguage('en'); // Fallback to English if browser language is not supported
    }
  }, []);

  useEffect(() => {
    patchMe(language);
    const cacheKey = `livquest_calvi_welcome_${language}`;
    getCache(cacheKey)
      .then((cachedMessage) => {
        console.log('Cached message:', cachedMessage);
        if (cachedMessage?.value) {
          setFirstMessage(cachedMessage.value);
        }
      })
      .catch((_err) => {
        if (!firstMessage) setFirstMessage(getFirstMessagesLivquestCalvi()[language]);
      });
  }, [language]);

  const onChangeLanguage = (option) => {
    setLanguage(option.value);
  };

  return (
    <>
      <div className="mt-24">
        <LivquestCalviLogo />
      </div>
      <div className="my-8">
        {['fr', 'en', 'it'].includes(language) && (
          <SelectField
            defaultValue={filteredLanguages.find((l) => l.value === language)}
            options={filteredLanguages}
            onChange={(option) => onChangeLanguage(option)}
          />
        )}
      </div>
      <ChatMessage
        message={{
          content: firstMessage,
          type: 'assistant',
          link: null,
        }}
      />
    </>
  );
};

export default HelloView;
